import { jsx as _jsx } from "react/jsx-runtime";
import { Button, notification } from "antd";
/**
 * FR-007 (UC-103, DEC-004): символы отказа при создании корп-заказа, после которых тот же заказ имеет смысл
 * оформить частным. Остальные ошибки показываются текстом без действия.
 */
export const PAYER_SWITCH_SYMBOLS = new Set([
    "CORP_COMPANY_NOT_FOUND",
    "CORP_COMPANY_NOT_ACTIVE",
    "CORP_LINK_NOT_ACTIVE",
    "CORP_LINK_EXPIRES_BEFORE_SCHEDULE",
    "CORP_CREDIT_LIMIT_EXCEEDED",
    "CORP_TARIFF_MISMATCH",
]);
const REFUSAL_KEY = "corp-order-refusal";
/**
 * Уведомление об отказе в корп-заказе: причина текстом и одно действие «Оформить как физлицо», которое
 * переключает плательщика и не трогает введённые данные (BR-ORD-07). Сумм, баланса и лимита нет (D14).
 */
export const notifyCorpRefusal = (text, onSwitchToPrivate) => {
    notification.error({
        key: REFUSAL_KEY,
        message: "Заказ не создан",
        description: text,
        duration: 0,
        actions: (_jsx(Button, { type: "primary", size: "small", onClick: onSwitchToPrivate, children: "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u043A\u0430\u043A \u0444\u0438\u0437\u043B\u0438\u0446\u043E" })),
    });
};
/** Закрыть уведомление об отказе — плательщика сменили (кнопкой в уведомлении или у формы). */
export const closeCorpRefusal = () => notification.destroy(REFUSAL_KEY);
